// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import axios from 'axios';
import Vue from 'vue';
import ElementUI from 'element-ui';
// eslint-disable-next-line
import vueiInfinite from 'vue-infinite-scroll';

import '@babel/polyfill';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import authService from '@/services/authService';
import App from './App';
import router from './router';
import './main.scss';

Vue.use(ElementUI);
Vue.use(vueiInfinite);

Vue.config.productionTip = false;
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.prototype.$message = ElementUI.Message;
// use interceptor to add auth token to every request exception login

// eslint-disable-next-line
function redirectToLoginPage() {
  const currentUrl = router.currentRoute.fullPath;
  if (currentUrl.indexOf('/new-login') === -1) {
    router.push({
      path: '/new-login',
      query: {
        redirect: currentUrl
      }
    });
  }
}

axios.interceptors.request.use(config => {
  if (config.url.indexOf('/api/login') === -1) {
    const who = authService.whoIsLoggedIn();
    if (who === 'yanbaocool') {
      const authToken = authService.getAuthToken();
      config.headers.Authorization = authToken;
    } else if (who === 'jianwei' && config.url.indexOf('api/user/check/authorize') === -1) {
      const jianWeiAuthToken = authService.getJianWeiAuthToken();
      config.headers.JianWeiAuthorization = jianWeiAuthToken;
    } else if (who === 'jianwei' && config.url.indexOf('api/user/check/authorize') !== -1) {
      // 见微用户的验证接口 /api/user/check/authorize 不能添加 JianWeiAuthorization 请求头
    } else if (who === 'yanbaocool-wechat') {
      const wechatAuthToken = authService.getWechatAuthToken();
      const wechatOpenidToken = authService.getWechatOpenid();
      config.headers.WechatAuthorization = wechatAuthToken;
      config.headers.openid = wechatOpenidToken;
    } else if (router.currentRoute.path === '/') {
      authService.logout();
    } else {
      authService.logout();
      router.push({
        path: '/'
      });
    }
  }
  return config;
});

axios.interceptors.response.use(
  response => {
    // 如果见微用户即将过期，会在response的header中携带新的token，需要更新token
    if (response.headers.Token && authService.whoIsLoggedIn === 'jianwei') {
      authService.updateJianWeiAuthToken(response.headers.Token);
    }
    return response;
  },
  error => {
    if (error.response.status === 401) {
      if (router.currentRoute.path === '/') {
        authService.logout();
        eventBus.$emit('getUserinfo');
      } else {
        authService.logout();
        router.push({
          path: '/'
        });
        eventBus.$emit('getUserinfo');
      }
    }
    if (error.response.status === 403) {
      eventBus.$emit('getUserinfo');
    }
    return Promise.reject(error);
  }
);

window.eventBus = new Vue();

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// });

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
